/* Sport Energy — Side-cart (JS)
   FASE 4.4.0 (26. august 2026). Fire rettelser i stepperen og anbefalingerne.
   (1) ANBEFALINGER: tilbage til tre kompakte raekker under hinanden med et
       plus-tegn, paa alle skaermbredder (de hoeje 3-kolonne-kort fra 3.2.0 er
       droppet). Plus bliver til et flueben naar varen er lagt i. Rent CSS +
       en lille brand/navn-deling i raekken, saa navnet ikke klippes af
       maerket.
   (2) CIFRE DER FLETTEDE SAMMEN: rollDigit() lod hvert tryk tilfoeje et nyt
       ciffer-span og fjernede det gamle efter 320 ms. Fem hurtige tryk gav
       fem spans i flugt oven i hinanden. Nu ryddes alle cifre der er paa vej
       ud, FOER det nye laegges ind; kun det nuvaerende ciffer glider ud.
   (3) ANTAL KAN SKRIVES: tryk paa tallet aabner et lille felt (numerisk
       tastatur paa mobil). Enter eller fokus-tab gemmer, Escape fortryder.
       0 fjerner varen; lagerloftet respekteres. Svag baggrund ved hover, saa
       kunden ser at tallet kan trykkes paa.
   (4) TALLET SPRANG TILBAGE ved hurtige tryk: et svar fra serveren paa et
       TIDLIGERE antal naaede frem efter kunden havde trykket videre, og
       renderCart() skrev det gamle tal ind. Nu koerer der aldrig mere end ét
       antal-kald pr. linje ad gangen (sendQty): er der et kald i luften, eller
       venter en debounce, ignoreres svaret og det nyeste tal sendes, naar
       kaldet er hjemme. Kun det sidste svar naar renderCart().
   FASE 4.3.0 (21. august 2026). Plus-knappen laases NAAR lageret er naaet, i
   stedet for at kunden opdager graensen ved at ramme den.

   HVORFOR DET KRAEVER ET ENDPOINT: lagertallet findes kun i server-renderet
   Liquid. Shopify fjerner inventory_quantity fra baade /products/<handle>.js
   og /cart.js, og quantity_rule paa en kurv-linje har max: null. Verificeret
   paa butikken. Derfor kalder vi vores egen lille template:
       /products/<handle>?view=lager
   som svarer med variant-id, antal og inventory_policy. Ét kald pr. produkt i
   kurven, kun naar panelet aabnes, og svaret huskes i hukommelsen.

   INGEN GRAENSE naar varen ikke spores (a er null) eller naar policy er
   "continue", for saa tillader butikken oversalg med vilje.

   422-VAERNET FRA 4.2.0 BLIVER STAAENDE. Opslaget kan vaere et par minutter
   gammelt paa grund af CDN-cache, saa lageret kan naa at falde imens. Det
   proaktive laas er en hoeflighed, ikke en garanti; vaernet er garantien.
   FASE 4.2.0 (21. august 2026). Kurven saa TOM ud naar lageret sagde nej.

   HVAD KUNDEN SAA: han havde en vare i kurven, trykkede plus for at faa flere
   end der var paa lager, og hele kurven blev tom med teksten "undefined varer".
   Varerne var der stadig paa serveren, men panelet viste en tom kurv.

   HVORFOR: /cart/change.js svarer 422 naar lageret ikke raekker, og kroppen er
   et FEJLOBJEKT, ikke en kurv:
       {"status":422,"message":"Cart Error","description":"..."}
   Koden kaldte .json() og sendte resultatet direkte til renderCart() uden
   nogensinde at se paa r.ok. Der laeste renderCart cart.items som undefined,
   faldt tilbage paa en tom liste og tegnede TOM-tilstanden: varer ryddet,
   footer skjult, fri fragt skjult, og i udvidet tilstand foldede panelet
   ovenikoebet sammen. Og fordi der ALDRIG blev kastet en fejl, koerte
   .catch(refresh) heller ikke. Kurven rettede sig altsaa ikke selv.

   RETTELSEN har tre lag, saa det ikke kan ske igen ad en anden vej:
   1) kurvSvar() tjekker r.ok og kaster en typet fejl med status og krop.
   2) renderCart() afviser alt der ikke ligner en kurv og henter friske tal i
      stedet. Et fejlobjekt kan aldrig mere blive laest som "tom kurv".
   3) Ved 422 rulles det optimistiske tal tilbage fra serveren, og linjen faar
      en rolig besked om at lageret er naaet. Vi skriver vores egen danske
      tekst; Shopifys "description" er engelsk og naevner et antal der ikke
      altid passer med det kunden ser.
   FASE 4.1.0 (7. august 2026). Den faste anbefalings-slot i SAMMENFOLDET
   tilstand er fjernet. Anbefalingerne bor nu altid i den scrollbare vareliste
   under varerne, som paa mobil og som FASE 1.3.0 oprindeligt besluttede.
   HVORFOR: slotten laa uden for varelisten og tog 281 px permanent. Maalt gav
   det en omvendt verden. En kunde med 900 px skaerm saa 1,9 varer, mens en med
   860 px saa 3,9 - den hoejere skaerm gav faerre varer, fordi den udloeste
   slotten. Den faste slot var aldrig et nettoplus for varelisten; den koebte
   paenere anbefalingskort for kundens overblik over sin egen kurv.
   Kortenes UDSEENDE er uaendret: slotten og varelisten er lige brede, begge
   inde i det 410 px brede panel, saa flytningen aendrer kun hvor de staar.
   Slot-elementet lever videre, men bruges nu KUN af udvid-tilstanden, hvor det
   er skinnens rullende midterfelt.
   FASE 4.0.0 (7. august 2026). Udvid-tilstand paa desktop.
   Kunden folder selv kurven ud til en arbejdsflade med to ruder. Valget gemmes
   i localStorage og gendannes kun hvor der er plads at udvide til, saa en
   telefon aldrig arver et desktop-valg.
   SOEJLEREGEL: to soejler kraever mindst 4 varer OG mindst 662 px i venstre
   rude (to raekker à 300 px plus mellemrum og polstring). Bredden foelger med,
   saa én soejle aldrig straekkes ud over en halvtom flade.
   LIVE SKIFT: krydser kurven fire varer mens den er udvidet, omfordeles der
   med FLIP. Positionerne maales RELATIVT til varelisten, ikke til skaermen.
   Panelet er hoejreforankret, saa naar bredden aendrer sig flytter hele
   indholdet sig med af sig selv; maalte vi mod skaermen, ville vi laegge den
   bevaegelse oveni og faa et hop paa praecis bredde-forskellen. Raekkernes
   bredde animerer med, ellers springer stepperen sidelaens mens raekken
   glider. Transitionen taendes én frame foer vaerdierne aendres, ellers kan
   browseren naa at regne slut-stilen ud foer transitionen findes.
   FLIP OVER EN GENGIVELSE: renderCart() erstatter hele innerHTML, saa
   "foer"-maalingen gemmes paa data-key og kobles til de NYE noder bagefter.
   prefers-reduced-motion respekteres: da skiftes der uden animation.
   FASE 3.10.0 (7. august 2026). Scroll-markering i bunden af varelisten.
   Listen scroller, men intet fortalte det. Naar footeren klipper en varelinje
   midt over, ser det ud som om listen slutter der, og paa mobil er der ingen
   musehjul-refleks til at afsloere sandheden. Ved 320 px ser kunden én vare ud
   af tre. En blod fade i bunden siger "her er mere" uden et eneste ord.
   Elementet bygges i JS og ikke i Liquid-blokken, saa deploy bliver ved med at
   vaere to asset-filer. Den skjules naar der ikke er mere at scrolle til, og
   opdateres ved scroll, aabning, gengivelse, flytning af anbefalinger og
   resize. pointer-events:none, saa den aldrig staar i vejen for et tryk eller
   for traek-i-sheet'en.
   FASE 3.9.0 (7. august 2026). Seks rettelser efter en kundehenvendelse og en
   Clarity-optagelse. Den vigtigste er (1):
   (1) HOEJDE-FEJL: anbefalingerne laa i .se-sc-rec-desktop-slot uden for den
   scrollbare body, som flex:0 0 auto. Sammen med head+ship+foot laaste det
   598 px fast inventar, og varelisten fik kun resten (vh minus 692). Paa en
   1280x720-skaerm blev der 29 px tilbage: kunden kunne ikke se en eneste af
   sine varer, kun anbefalinger og betalingsknappen. Desktop-slotten kraever nu
   OGSAA min-height:900px; derunder bor anbefalingerne i body under varerne,
   praecis som FASE 1.3.0 besluttede for mobil og af samme grund.
   (2) Kurv-ikonet er nu en TOGGLE. Et klik mens panelet stod aabent kaldte
   open() der returnerede tidligt: ingenting skete, et rent dead click.
   (3) KAPACITETSPORT oeverst: kan browseren ikke fetch + closest, roerer vi
   intet. Kurv-ikonet forbliver et almindeligt link til /cart, og kunden faar
   temaets kurv-side i stedet for et doedt ikon.
   (4) bindCartTriggers() er flyttet til BUNDEN. Den laa 20 pct inde i filen med
   80 pct af initialiseringen bagefter; kastede noget af det, var ikonet kapret
   og dodt. Nu kapres linket foerst naar panelet beviseligt er klar.
   (5) DEAD-CLICK-MAALER: klik i panelet der ikke rammer en kontrol sendes til
   Clarity med zone-tag. Maks ét pr. aabning. Defensivt: analytics maa aldrig
   knaekke kurv-flowet.
   (6) Doed kode i renderCart fjernet (tom ternaer paa minus-knappen).
   FASE 3.6.0 (30. juli 2026) — Trustpilot-stjernerne bruger nu Trustpilots
   EGEN stjerneform (path fra deres stars-5.svg, viewBox 0 0 96 96) og deres
   EGEN afrunding: rest >= .75 giver en HEL stjerne, .25-.74 en halv, under
   .25 ingen. Samme form og samme regel som forside-anmeldelserne, saa
   signalet er ét og det samme hele vejen igennem. 4,8 -> fem hele stjerner.
   FASE 3.5.0 (3. juli 2026) — maaling af anbefalings-effektivitet tre steder:
   (1) skjult line item property (_kilde:"sidecart-anbefaling") vedhaeftes naar
   en anbefaling laegges i kurven, saa den ses direkte paa ordren i admin;
   (2) GA4 add_to_cart-event med source-markoer; (3) Clarity custom tag + event.
   Alle tre defensivt kaldt — analytics maa aldrig knaekke kurv-flowet.
   FASE 3.2.0 (2. juli 2026) — anbefalinger laast til tre kort der deler
   vinduets bredde (ingen scroll-carousel). Roligere og mere kurateret; lader
   checkout vaere den staerkeste handling. Kun visningen skaeres; motoren
   henter stadig sit fulde saet.
   FASE 3.1.0 (2. juli 2026) — desktop-vinduet er nu NON-MODAL: det laegger sig
   paa siden uden at spaerre den (ingen scroll-laas, gennemsigtig backdrop,
   loesnet fokus-faelde), saa man kan scrolle og navigere videre med kurven
   aaben. Klik uden for vinduet lukker det. Mobil-sheet'en forbliver modal.
   FASE 3.0.0 (2. juli 2026) — svaevende vindue (variant A): panelet er nu et
   loeftet, hjoerne-forankret vindue frem for en kant-til-kant-skuffe. Drag-to-
   dismiss vaelger akse efter form: desktop lukker mod hoejre, mobil (bottom-
   sheet) lukker nedad. Geometrien bor i CSS; her aendres kun drag-aksen.
   FASE 2.8.0 (2. juli 2026) — oprydning (review 10-15): (10) doed checkoutUrl-
   config fjernet; (12) fri-fragt-grundlag = total_price (fragten er Shipmondo-
   carrier-beregnet og ser rabatteret subtotal — verificeret via Admin API);
   (13) oere-drift ved skaeve rabatter dokumenteret som accepteret (server-sync
   retter); (15) will-change styres nu her: kun under aabn/luk/drag.
   FASE 2.7.0 (2. juli 2026) — polering (review 6-9): (6) antal annonceres via
   skjult aria-live-region, rullet er aria-hidden (laeste "67" op); (7) hit-
   arealer udvidet til ~44px via pseudo-elementer, visuelt uaendret (WCAG
   2.5.8); (8) anbefalinger re-filtreres mod kurvens aktuelle indhold ved hver
   aendring (cache pr. grundlag; nyt fetch kun ved ny foerste vare); (9) server-
   render springer DOM-genbygning over naar strukturen matcher — kapper ikke
   laengere ciffer-rullet; priser/data-unit synkes stadig.
   FASE 2.6.0 (2. juli 2026) — review-rettelser: (1) aria-hidden toggles nu paa
   open/close (var permanent true: dialog usynlig for skaermlaesere, EAA-brud);
   (2) minus-til-nul fjerner optimistisk som skraldespanden; (3) egne kurv-
   skrivninger udloeser ikke laengere ekstra watcher-refresh (dobbelt hentning
   + render-race); (4) billed-width appendes med betinget ?/& (blind & knak
   billeder uden query). Versions-header konsolideret — 1.5.0-2.5.0 manglede
   her, fordi sed-bumps fejlede stille; fremover kun count==1-validerede patches.
   FASE 2.5.0 — "67"-bug: antal laeses fra data-qty, aldrig fra animeret tekst.
   FASE 2.4.0 — bar uden sort kant: ingen viewBox-straek, stroke=none (Ella
   saetter stroke:currentColor paa svg).
   FASE 2.3.0 — Trustpilot uden anmeldelses-antal (lavt tal skader tilliden).
   FASE 2.2.0 — TP 4,7 "Fremragende", sidste stjerneflise delvist fyldt; ren bar.
   FASE 2.1.0 — Trustpilot mikro-linje (variant B) under betalingsknappen.
   FASE 2.0.0 — fri-fragt-bar som inline SVG: fill/width som attributter,
   uangribelige for tema-CSS (loeste den vedholdende graa bar).
   FASE 1.9.0 — "Endnu" -> "Kun"; inline farve-forsoeg (afloest af 2.0.0).
   FASE 1.8.0 — maerke som separat label; unikt navn line-clamp 2.
   FASE 1.7.0 — optimistisk UI: instant rec-flueben, optimistisk stepper-
   totaler, debounced netvaerk, instant fjernelse.
   FASE 1.5.0-1.6.2 — rec-layout pr. breakpoint; fill-farve-forsoeg (afloest).
   FASE 1.4.0 — kompakte vandrette anbefalings-raekker; cirkel-plus.
   FASE 1.3.0 — anbefalinger scroller nu sammen med varerne (i body).
   FASE 1.2.0 — is-near-tilstand fra 66 pct af fri-fragt-graensen.
   FASE 1.1.0 — has-progress-klasse styrer synlig min-fyldning.
   FASE 1.0.0 — egen side-cart, erstatter Kaching Cart Drawer.
   Deler cart-watcher-register (window.__seCartWatchers) med header + mobil-nav:
   fetch wrappes kun ÉN gang på tværs af alle tre (ingen dobbelt cart.js-kald).
   Routes/config via window.SESidecart (sat i Liquid-blokken, da asset-JS ikke
   kan rendere Liquid).

   Motion efter fluid-principperne: højre-drawer, blød fjeder ind, backdrop kun
   opacitet, snappy stepper med rullende ciffer, drag-to-dismiss mod højre
   (rumlig konsistens: åbner fra højre → lukker mod højre), rubber-band mod
   venstre, velocity-flick. Anbefalinger fra Shopifys /recommendations/products.
   Nordisk-stoisk: ingen udråbstegn, ingen urgency, rolig tom-tilstand. */

(function () {
  var root = document.querySelector('.se-sc');
  if (!root) return;

  // ── Kapacitetsport (FASE 3.9.0) ──
  // Panelet kraever fetch() og Element.closest(). Mangler en af dem, stopper vi
  // FOER vi binder os paa kurv-ikonet. Saa forbliver ikonet et almindeligt link
  // til /cart, og kunden lander paa temaets kurv-side i stedet for at trykke paa
  // et ikon der ikke svarer. Fallbacken er browserens egen, ikke vores.
  if (!window.fetch || !Element.prototype.closest) return;

  var cfg = (window.SESidecart || {});
  cfg = {
    cartUrl:       cfg.cart_url        || '/cart',
    routeRoot:     cfg.root_url        || '/',
    guideUrl:      cfg.guide_url       || '/pages/find-dine-produkter',
    freeShip:      (typeof cfg.free_shipping_threshold === 'number') ? cfg.free_shipping_threshold : 599,
    recommend:     cfg.recommend !== false,
    recIntent:     cfg.rec_intent     || 'related',
    tpScore:       cfg.tp_score       || '4,7',
    tpLabel:       cfg.tp_label       || 'Fremragende'
  };

  // Flyt fladen ud til <body>: Ella wrapper Custom Liquid i en shopify-section
  // der kan have transform, og en transform-forælder gør position:fixed relativ
  // til sig selv (ikke viewporten). Under <body> er der ingen transform-forælder.
  var backdrop = root.querySelector('.se-sc-backdrop');
  var panel    = root.querySelector('.se-sc-panel');
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var body   = document.body;
  var lastFocus = null;
  var isOpen = false;
  var modal = false;
  var deadClickSendt = false; // FASE 3.9.0: ét dead-click-signal pr. aabning

  // ── Udvid-tilstand (FASE 4.0.0) ──
  var UDVID_NOEGLE   = 'se_sc_udvidet';
  var SKINNE_BREDDE  = 312;   // hoejre soejle
  var LISTE_POLSTRING= 40;    // .se-sc-items har 20px i hver side
  var SOEJLE_GAB     = 22;
  var MIN_RAEKKE     = 300;   // smalleste rimelige varelinje
  var BRED_2         = 1040;  // to soejler
  var BRED_1         = SKINNE_BREDDE + LISTE_POLSTRING + 420; // 772, én soejle
  var SMAL           = 410;
  var MIN_VARER_TIL_2= 4;
  var MIN_SKAERM     = 640;   // under denne fylder panelet allerede bredden
  var FLIP_MS        = 440;
  var erUdvidet = false, varerAntal = 0, flipTimer = null, flipTaeller = 0;

  // Spor tastatur vs. tap, så programmatisk fokus (og fokus-ring) kun sættes ved
  // tastatur — ikke ved tap (iOS Safari viser ellers en ring efter tap).
  var usingKeyboard = false;
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') usingKeyboard = true; }, true);
  document.addEventListener('pointerdown', function () { usingKeyboard = false; }, true);
  function focusIfKeyboard(el) { if (el && usingKeyboard) el.focus(); }

  // ── Hjælpere ──────────────────────────────────────────────────────────
  function money(kr) {
    return kr.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr.';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Titler har form "Maurten Gel 160 | Neutral": navn før |, smag/variant efter.
  function splitTitle(t) {
    var parts = String(t || '').split('|');
    return { name: parts[0].trim(), flavour: parts.length > 1 ? parts.slice(1).join('|').trim() : '' };
  }
  // Variant-tekst: hvis smag ligger i titlen bruges den, ellers variant-title
  // (undtagen "Default Title"). Undgår at gentage navnet.
  function variantLabel(item) {
    var st = splitTitle(item.product_title || item.title);
    if (st.flavour) return st.flavour;
    var v = item.variant_title;
    if (v && v !== 'Default Title') return v;
    return '';
  }
  // Fjern mærket fra starten af navnet, saa det UNIKKE (fx "PH 1500 Drink Mix")
  // faar pladsen i den smalle kolonne i stedet for at "Precision Fuel &
  // Hydration" fylder alt og det unikke klippes af. Mærket vises separat, lille.
  // cart.js leverer item.vendor. Vi stripper kun hvis navnet faktisk starter
  // med mærket (case-insensitivt), ellers roerer vi ikke navnet.
  function brandSplit(item) {
    var st = splitTitle(item.product_title || item.title);
    var name = st.name;
    var vendor = (item.vendor || '').trim();
    if (vendor && name.toLowerCase().indexOf(vendor.toLowerCase()) === 0) {
      var rest = name.slice(vendor.length).replace(/^[\s\-–|:]+/, '').trim();
      // Kun strip hvis der er noget unikt tilbage (ellers stod mærket alene).
      if (rest) return { brand: vendor, name: rest };
    }
    return { brand: vendor, name: name };
  }
  // cart.js leverer priser i ØRE (heltal), fx 2900 = 29,00 kr. (I MODSÆTNING til
  // predictive /search/suggest.json, der leverer kroner-streng.) Del med 100.
  function ore(x) { return (x == null ? 0 : x) / 100; }
  // Shopify-CDN-stoerrelse: appender width korrekt uanset om URL'en allerede
  // har en query-string. Blind '&width=' knak billeder uden ?v=-parameter.
  function sized(u, w) {
    if (!u) return u;
    u = String(u);
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  // Punkt 15: will-change kun mens panelet faktisk bevaeger sig (aabn/luk/
  // drag). Permanent will-change i CSS holdt et compositing-lag i live hele
  // sessionen for ingenting. holdWill saetter laget; releaseWill rydder det
  // foerst naar transitionen er faerdig (550ms > 500ms fjeder).
  var willTimer = null;
  function holdWill() {
    if (willTimer) { clearTimeout(willTimer); willTimer = null; }
    panel.style.willChange = 'transform';
  }
  function releaseWill() {
    if (willTimer) clearTimeout(willTimer);
    willTimer = setTimeout(function () { panel.style.willChange = ''; willTimer = null; }, 550);
  }

  // ── Åbn / luk ───────────────────────────────────────────────────────────
  function open() {
    if (isOpen) return;
    isOpen = true;
    deadClickSendt = false; // ét dead-click-signal pr. aabning (FASE 3.9.0)
    lastFocus = document.activeElement;
    // A11y: roden staar aria-hidden="true" i Liquid (lukket tilstand). Den SKAL
    // toggles her, ellers er hele dialogen usynlig for skaermlaesere mens
    // fokus-faelden flytter fokus ind i "skjult" indhold (EAA-brud).
    root.setAttribute('aria-hidden', 'false');
    // Modal paa mobil (bottom-sheet fylder skaermen), non-modal paa desktop
    // (svaevende vindue — siden bag skal kunne scrolles og navigeres).
    modal = window.matchMedia('(max-width:520px)').matches;
    root.setAttribute('data-modal', modal ? '1' : '0');
    holdWill(); releaseWill(); // compositing-lag kun under aabnings-fjederen
    backdrop.classList.add('is-open');
    panel.classList.add('is-open');
    if (modal) body.style.overflow = 'hidden';   // scroll-laas kun i modal
    focusIfKeyboard(panel.querySelector('.se-sc-close'));
    // Non-modal: klik et vilkaarligt sted uden for vinduet lukker det (samme
    // rolige gestus som backdroppen gav, uden at spaerre siden). Tilfoejes paa
    // naeste tick, saa selve aabnings-klikket ikke straks lukker igen.
    if (!modal) setTimeout(function () { document.addEventListener('mousedown', outsideClose, true); }, 0);
    // Panelet har foerst hoejde naar det er aabent, saa markeringen regnes ud
    // paa naeste tick frem for med det samme.
    setTimeout(opdaterFade, 0);
    refresh(); // hent altid friske tal ved åbning
  }
  // Luk ved klik uden for panelet (kun non-modal/desktop).
  function outsideClose(e) {
    if (!isOpen) return;
    if (panel.contains(e.target)) return;               // klik i kurven: behold
    if (e.target.closest && e.target.closest('[data-se-cart-open], a[href$="/cart"], #se-cart-link, .se-mcart')) return;
    close();
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.setAttribute('aria-hidden', 'true');
    holdWill(); releaseWill(); // og under luk-transitionen
    backdrop.classList.remove('is-open');
    panel.classList.remove('is-open');
    body.style.overflow = '';
    document.removeEventListener('mousedown', outsideClose, true);
    if (usingKeyboard && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.SESidecartOpen = open; // så andre komponenter kan åbne den

  var closeBtn = panel.querySelector('.se-sc-close');
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (backdrop) backdrop.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

  // Fokus-fælde: KUN i modal (mobil-sheet). I det non-modale desktop-vindue
  // skal Tab kunne forlade kurven igen — resten af siden er jo levende.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !isOpen || !modal) return;
    var all = panel.querySelectorAll('a[href], button:not([disabled]), input');
    var vis = [];
    for (var i = 0; i < all.length; i++) { if (all[i].offsetParent !== null) vis.push(all[i]); }
    if (!vis.length) return;
    var first = vis[0], last = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  // ══════════════════════════════════════════════════════════════════════
  //  UDVID-TILSTAND (FASE 4.0.0)
  // ══════════════════════════════════════════════════════════════════════
  function roligBevaegelse() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  }
  function pladsLoft() { return window.innerWidth - 80; }
  function knapSkalVises() { return window.innerWidth >= MIN_SKAERM; }

  // Indholdsstyret: bredde OG soejletal foelger antallet af varer.
  function beregnLayout() {
    if (!erUdvidet || !knapSkalVises()) {
      return { bredde: null, kolonner: 1 };   // null = lad CSS bestemme
    }
    var vil2 = varerAntal >= MIN_VARER_TIL_2;
    var bredde = Math.min(vil2 ? BRED_2 : BRED_1, pladsLoft());
    var venstre = bredde - SKINNE_BREDDE;
    var kolonner = (vil2 && venstre >= (MIN_RAEKKE * 2 + SOEJLE_GAB + LISTE_POLSTRING)) ? 2 : 1;
    // Faldt vi til én soejle af pladsmangel, skal bredden ikke blive staaende
    // paa to-soejle-maalet med en halvtom flade til foelge.
    if (kolonner === 1 && vil2) bredde = Math.min(BRED_1, pladsLoft());
    return { bredde: bredde, kolonner: kolonner };
  }

  function gemUdvid(v) { try { localStorage.setItem(UDVID_NOEGLE, v ? '1' : '0'); } catch (e) {} }
  function laesUdvid() { try { return localStorage.getItem(UDVID_NOEGLE) === '1'; } catch (e) { return false; } }

  // Positioner MAALT RELATIVT til varelisten. Se noten i filhovedet.
  function maalLinjer() {
    if (!elItems) return {};
    var b = elItems.getBoundingClientRect(), ud = {};
    var raekker = elItems.querySelectorAll('.se-sc-item');
    for (var i = 0; i < raekker.length; i++) {
      var el = raekker[i], n = el.getAttribute('data-key');
      if (!n) continue;
      var r = el.getBoundingClientRect();
      ud[n] = { x: r.left - b.left, y: r.top - b.top, w: r.width };
    }
    return ud;
  }

  function ryddFlip(raekker) {
    for (var i = 0; i < raekker.length; i++) {
      raekker[i].classList.remove('se-sc-flip');
      raekker[i].style.transform = '';
      raekker[i].style.width = '';
    }
  }

  // foerMap: resultat af maalLinjer() taget FOER DOM'en blev roert. Uden den
  // laves der ingen FLIP, kun et direkte skift.
  function anvendLayout(foerMap) {
    if (!panel || !elItems) return;
    var m = beregnLayout();
    var nyKol = String(m.kolonner);
    var gammelKol = elItems.getAttribute('data-cols') || '1';
    var startBredde = Math.round(panel.getBoundingClientRect().width);

    function saetDirekte() {
      if (m.bredde == null) panel.style.width = '';
      else panel.style.width = m.bredde + 'px';
      elItems.setAttribute('data-cols', nyKol);
    }

    if (!foerMap || roligBevaegelse()) { saetDirekte(); opdaterFade(); return; }

    var raekker = [];
    var alle = elItems.querySelectorAll('.se-sc-item');
    for (var i = 0; i < alle.length; i++) {
      if (foerMap[alle[i].getAttribute('data-key')]) raekker.push(alle[i]);
    }
    if (!raekker.length) { saetDirekte(); opdaterFade(); return; }

    // LAST: saet slutgeometrien uden at vise den, og maal.
    ryddFlip(raekker);
    panel.style.transition = 'none';
    saetDirekte();
    void panel.offsetWidth;
    var efter = maalLinjer();

    // Ingen reel forskel? Saa ingen animation.
    var noget = false;
    for (var k = 0; k < raekker.length; k++) {
      var n2 = raekker[k].getAttribute('data-key');
      var a = foerMap[n2], b2 = efter[n2];
      if (!a || !b2) continue;
      if (Math.abs(a.x - b2.x) > .5 || Math.abs(a.y - b2.y) > .5 || Math.abs(a.w - b2.w) > .5) noget = true;
    }
    if (!noget && startBredde === Math.round(panel.getBoundingClientRect().width)) {
      panel.style.transition = ''; opdaterFade(); return;
    }

    // Tilbage til start: omvendt forskydning OG gammel bredde paa hver raekke.
    panel.style.width = startBredde + 'px';
    for (var q = 0; q < raekker.length; q++) {
      var n3 = raekker[q].getAttribute('data-key');
      var f = foerMap[n3], e2 = efter[n3];
      if (!f || !e2) continue;
      var dx = f.x - e2.x, dy = f.y - e2.y;
      raekker[q].style.width = f.w + 'px';
      raekker[q].style.transform = (Math.abs(dx) < .5 && Math.abs(dy) < .5)
        ? '' : 'translate(' + dx + 'px,' + dy + 'px)';
    }
    void panel.offsetWidth;
    panel.style.transition = '';
    panel.style.willChange = 'width';

    var denne = ++flipTaeller;
    requestAnimationFrame(function () {
      for (var s = 0; s < raekker.length; s++) raekker[s].classList.add('se-sc-flip');
      requestAnimationFrame(function () {
        if (denne !== flipTaeller) return;
        for (var t = 0; t < raekker.length; t++) {
          var n4 = raekker[t].getAttribute('data-key');
          raekker[t].style.transform = '';
          if (efter[n4]) raekker[t].style.width = efter[n4].w + 'px';
        }
        if (m.bredde == null) panel.style.width = '';
        else panel.style.width = m.bredde + 'px';
      });
    });
    if (flipTimer) clearTimeout(flipTimer);
    flipTimer = setTimeout(function () {
      if (denne !== flipTaeller) return;
      ryddFlip(raekker);
      panel.style.willChange = '';
      opdaterFade();
    }, FLIP_MS + 60);
    opdaterFade();
  }

  function saetUdvidKnap() {
    if (!knapUdvid) return;
    if (knapSkalVises()) knapUdvid.removeAttribute('hidden');
    else knapUdvid.setAttribute('hidden', '');
    var t = erUdvidet ? 'Fold kurven sammen' : 'Udvid kurven';
    knapUdvid.setAttribute('aria-label', t);
    knapUdvid.setAttribute('title', t);
    knapUdvid.setAttribute('aria-expanded', erUdvidet ? 'true' : 'false');
  }

  function saetUdvidet(v, blod) {
    if (!knapSkalVises()) v = false;
    erUdvidet = !!v;
    panel.classList.toggle('is-wide', erUdvidet);
    saetUdvidKnap();
    placeRec();
    anvendLayout(blod ? maalLinjer() : null);
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', erUdvidet ? 'sidecart_udvidet' : 'sidecart_foldet');
      }
    } catch (e) {}
  }

  // Knappen bygges i JS, saa Liquid-blokken ikke skal roeres ved deploy.
  var knapUdvid = null;
  (function () {
    var hoved = panel.querySelector('.se-sc-head');
    var luk = hoved && hoved.querySelector('.se-sc-close');
    if (!hoved || !luk || !document.createElement) return;
    var pakke = document.createElement('div');
    pakke.className = 'se-sc-head-btns';
    knapUdvid = document.createElement('button');
    knapUdvid.type = 'button';
    knapUdvid.className = 'se-sc-udvid';
    knapUdvid.innerHTML =
      '<svg class="se-sc-ik-ud" viewBox="0 0 24 24"><polyline points="15 3 21 3 21 9"></polyline>' +
      '<polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line>' +
      '<line x1="3" y1="21" x2="10" y2="14"></line></svg>' +
      '<svg class="se-sc-ik-ind" viewBox="0 0 24 24"><polyline points="4 14 10 14 10 20"></polyline>' +
      '<polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line>' +
      '<line x1="3" y1="21" x2="10" y2="14"></line></svg>';
    hoved.insertBefore(pakke, luk);
    pakke.appendChild(knapUdvid);
    pakke.appendChild(luk);
    knapUdvid.addEventListener('click', function () {
      saetUdvidet(!erUdvidet, true);
      gemUdvid(erUdvidet);
    });
  })();

  window.addEventListener('resize', function () {
    if (erUdvidet && !knapSkalVises()) { saetUdvidet(false, false); return; }
    saetUdvidKnap();
    anvendLayout(null);
  });

  // Gendan det huskede valg. Kun hvor der er plads at udvide til.
  if (laesUdvid() && knapSkalVises()) saetUdvidet(true, false);
  else saetUdvidKnap();

  // ── Kobling til kurv-ikoner + læg-i-kurv (åbn i stedet for at navigere) ──
  // Enhver header/mobil-kurv-ikon-tap åbner drawer'en frem for at gå til /cart.
  function bindCartTriggers() {
    var triggers = document.querySelectorAll('a[href$="/cart"], #se-cart-link, [data-se-cart-open], .se-mcart');
    for (var i = 0; i < triggers.length; i++) {
      (function (el) {
        if (el.__seBound) return; el.__seBound = true;
        el.addEventListener('click', function (e) {
          // lad ctrl/cmd-klik (åbn i ny fane) passere uændret
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          e.preventDefault();
          // FASE 3.9.0: TOGGLE. Foer kaldte den altid open(), og open() vender
          // tilbage med det samme naar panelet allerede staar aabent, og et klik
          // paa kurv-ikonet gjorde da bogstaveligt talt ingenting. outsideClose
          // undtager netop disse ikoner, saa mousedown lukker ikke foerst; det
          // er dette klik der lukker.
          if (isOpen) close(); else open();
        });
      })(triggers[i]);
    }
  }
  // FASE 3.9.0: selve KALDET er flyttet til bunden af filen. Se noten der.

  // ── Delt cart-watcher-register (samme som header + mobil) ──
  function isCartWrite(u) {
    if (typeof u !== 'string') return false;
    return u.indexOf('/cart/add') >= 0 || u.indexOf('/cart/change') >= 0 ||
           u.indexOf('/cart/update') >= 0 || u.indexOf('/cart/clear') >= 0;
  }
  // fetch wrappes kun ÉN gang på tværs af header/mobil/side-cart. Det delte
  // register skelner ikke mellem add og change — så vi lægger en separat
  // "åbn ved add"-liste ved siden af, og wrapper kun hvis ingen har gjort det.
  if (!window.__seCartAddHooks) window.__seCartAddHooks = [];
  if (!window.__seCartWatchers) {
    window.__seCartWatchers = [];
    var _fetch = window.fetch;
    window.fetch = function () {
      var a = arguments, u = (a[0] && a[0].url) || a[0] || '';
      return _fetch.apply(this, a).then(function (res) {
        if (isCartWrite(u)) { for (var i = 0; i < window.__seCartWatchers.length; i++) window.__seCartWatchers[i](); }
        if (typeof u === 'string' && u.indexOf('/cart/add') >= 0) {
          for (var j = 0; j < window.__seCartAddHooks.length; j++) window.__seCartAddHooks[j]();
        }
        return res;
      });
    };
  } else if (!window.__seCartAddWired) {
    // Header/mobil har allerede wrappet fetch UDEN add-hook-kald. Læg et ekstra
    // wrap ovenpå, der KUN udløser add-hooks (ændrer ikke watcher-adfærd).
    window.__seCartAddWired = true;
    var _fetch2 = window.fetch;
    window.fetch = function () {
      var a = arguments, u = (a[0] && a[0].url) || a[0] || '';
      var p = _fetch2.apply(this, a);
      if (typeof u === 'string' && u.indexOf('/cart/add') >= 0) {
        p.then(function () { for (var j = 0; j < window.__seCartAddHooks.length; j++) window.__seCartAddHooks[j](); }).catch(function () {});
      }
      return p;
    };
  }
  // Opdatér tal ved enhver kurv-skrivning; åbn drawer'en ved /cart/add.
  window.__seCartWatchers.push(function () {
    if (selfWrites > 0) { selfWrites--; return; } // vores egen skrivning: response-render klarer det
    refresh();
  });
  window.__seCartAddHooks.push(function () { setTimeout(open, 60); });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && String(f.action).indexOf('/cart/add') >= 0) {
      // Ella/temaer kan submitte via ajax; åbn efter kort delay uanset.
      setTimeout(open, 200);
    }
  }, true);
  ['cart:updated', 'cart:refresh', 'kaching:cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function () { refresh(); });
  });

  // ── Rendering ────────────────────────────────────────────────────────────
  var elItems  = panel.querySelector('.se-sc-items');
  var elEmpty  = panel.querySelector('.se-sc-empty');
  var elFoot   = panel.querySelector('.se-sc-foot');
  var elShip   = panel.querySelector('.se-sc-ship');
  var elRec    = panel.querySelector('.se-sc-rec');
  var elSubVal = panel.querySelector('.se-sc-sub .v');
  var elCount  = panel.querySelector('.se-sc-title .n');

  // Trustpilot-linje (variant B): fyld label + STJERNER fra config.
  // Antal anmeldelser vises bevidst IKKE (aendrer sig; lavt tal skader tilliden).
  // Stjernerne tegnes fra score (fx 4,7 -> fire hele + én 70 pct fyldt flise).
  (function initTrustpilot() {
    var tp = panel.querySelector('.se-sc-tp');
    if (!tp) return;
    var labelEl = tp.querySelector('.se-sc-tp-label');
    var starsEl = tp.querySelector('.se-sc-tp-stars');
    if (labelEl && cfg.tpLabel) labelEl.textContent = cfg.tpLabel;
    var score = parseFloat(String(cfg.tpScore || '0').replace(',', '.')) || 0;
    if (starsEl) {
      starsEl.innerHTML = buildTpStars(score);
      starsEl.setAttribute('role', 'img');
      starsEl.setAttribute('aria-label', String(cfg.tpScore || score) + ' ud af 5 stjerner');
    }
  })();

  // Byg 5 Trustpilot-fliser. Formen er Trustpilots EGEN stjerne — samme path
  // som forside-anmeldelserne henter fra deres stars-5.svg (viewBox 0 0 96 96,
  // afskaaret venstre flig, skarpe hjoerner). Stjernen er "stanset ud" af
  // flisen: flisen baerer farven, stjernen er hvid.
  // Afrundingen foelger Trustpilots egen, ikke en lineaer fyldning: rest
  // >= .75 giver en HEL stjerne mere, .25-.74 giver en halv, under .25 giver
  // ingen. Derfor viser 4,8 fem hele stjerner — praecis som paa Trustpilot.
  function buildTpStars(score) {
    var hele = Math.floor(score);
    var rest = score - hele;
    if (rest >= 0.75) { hele = hele + 1; rest = 0; }
    if (hele > 5) hele = 5;
    var halvPos = rest >= 0.25 ? hele + 1 : 0;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var bg = '#00b67a';
      if (i > hele) {
        bg = (i === halvPos) ? 'linear-gradient(90deg,#00b67a 50%,#dcdce6 50%)' : '#dcdce6';
      }
      html +=
        '<span class="se-sc-tp-star" style="background:' + bg + '">' +
          '<svg viewBox="0 0 96 96" aria-hidden="true">' +
            '<path d="M48,64.7L62.6,61l6.1,18.8L48,64.7z M81.6,40.4H55.9L48,16.2l-7.9,24.2H14.4l20.8,15l-7.9,24.2l20.8-15l12.8-9.2L81.6,40.4z"/>' +
          '</svg>' +
        '</span>';
    }
    return html;
  }

  // ── Anbefalingernes placering skifter på breakpoint ──
  // Mobil (<1024px): elementet bor inde i .se-sc-body under varerne (kompakte
  // raekker). Desktop (>=1024px): JS flytter det til .se-sc-rec-desktop-slot
  // (fast sektion over footeren, hoeje kort). Samme element, to placeringer.
  var elBody   = panel.querySelector('.se-sc-body');
  var elDeskSlot = panel.querySelector('.se-sc-rec-desktop-slot');
  // FASE 3.9.0: kravet er nu BREDDE OG HOEJDE. Desktop-slotten ligger uden for
  // den scrollbare body som fast inventar; sammen med head+ship+foot laaste den
  // 598 px, og varelisten fik kun vh minus 692. Under 900 px hoejde bor
  // anbefalingerne derfor i body under varerne. Samme loesning som FASE 1.3.0
  // valgte for mobil, og af noejagtig samme grund: kundens egen kurv skal aldrig
  // tabe pladskampen til anbefalinger. CSS' media query er rettet tilsvarende.
  // FASE 4.1.0: hoejde-media-queryen er vaek. Placeringen afhaenger nu kun af
  // om panelet er udvidet, og det er en tilstand vi selv styrer.
  function placeRec() {
    if (!elRec || !elBody || !elDeskSlot) return;
    // FASE 4.1.0: slotten bruges KUN naar panelet er udvidet, hvor den er
    // skinnens rullende midterfelt. Ellers bor anbefalingerne i varelisten
    // under varerne, saa de aldrig tager plads fra kundens egen kurv.
    if (erUdvidet) {
      if (elRec.parentNode !== elDeskSlot) elDeskSlot.appendChild(elRec);
    } else {
      if (elRec.parentNode !== elBody) elBody.appendChild(elRec);
    }
    // Markeringen skal blive ved med at vaere sidste barn, ellers stikker
    // anbefalingerne ud under den.
    if (elFade && elFade.parentNode === elBody) elBody.appendChild(elFade);
    if (typeof opdaterFade === 'function') opdaterFade();
  }
  // ── Scroll-markering (FASE 3.10.0) ──
  // Sidste barn i den scrollbare body, sticky mod bunden, negativ topmargin saa
  // den ikke selv laegger hoejde til scrollHeight.
  var elFade = null;
  if (elBody && document.createElement) {
    elFade = document.createElement('div');
    elFade.className = 'se-sc-fade';
    elFade.setAttribute('aria-hidden', 'true');
    elFade.hidden = true;
    elBody.appendChild(elFade);
  }
  function opdaterFade() {
    if (!elFade || !elBody) return;
    // 8 px slup: sub-pixel-afrunding maa ikke lade den blinke i bunden.
    var mere = elBody.scrollHeight - elBody.clientHeight - elBody.scrollTop > 8;
    if (mere) elFade.removeAttribute('hidden');
    else elFade.setAttribute('hidden', '');
  }
  if (elBody) elBody.addEventListener('scroll', opdaterFade);
  window.addEventListener('resize', opdaterFade);

  placeRec();
  // (FASE 4.1.0: media-query-lytteren er fjernet sammen med hoejde-reglen.)

  var lastSubtotal = null;

  // FIX 9: matcher DOM'ens linjer allerede serverens (samme keys, samme antal,
  // ingen foer-priser der skal genbygges), springes innerHTML-genbygningen over
  // — server-svaret 260ms efter et tryk kappede ellers ciffer-rullet (320ms).
  function domMatchesServer(items) {
    if (!elItems) return false;
    var lines = elItems.querySelectorAll('.se-sc-item');
    if (lines.length !== items.length) return false;
    for (var i = 0; i < items.length; i++) {
      if (lines[i].getAttribute('data-key') !== items[i].key) return false;
      var qe = lines[i].querySelector('.se-sc-qty');
      if (!qe || parseInt(qe.getAttribute('data-qty'), 10) !== items[i].quantity) return false;
      // Foer-pris (udsalg) kraever fuld markup — lad de linjer genbygge.
      if (lines[i].querySelector('.se-sc-line-was')) return false;
    }
    return true;
  }
  // Ved skip synkes priser + data-unit stadig fra serveren, saa oere-drift fra
  // den optimistiske beregning aldrig bliver staaende.
  function syncLinesFromServer(items) {
    var lines = elItems.querySelectorAll('.se-sc-item');
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var unit = it.quantity ? Math.round(it.final_line_price / it.quantity) : it.final_line_price;
      lines[i].setAttribute('data-unit', unit);
      var priceEl = lines[i].querySelector('.se-sc-line-price');
      if (priceEl) priceEl.textContent = money(ore(it.final_line_price));
    }
  }

  function stepperSvg(kind) {
    return kind === 'plus'
      ? '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'
      : '<svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  }

  function renderCart(cart) {
    // VAERN (FASE 4.2.0): et objekt uden items-liste er ikke en kurv. Uden det
    // her blev Shopifys 422-fejlobjekt laest som en tom kurv, og kunden saa
    // "undefined varer" og en tom liste selvom varerne laa der. Vi henter
    // friske tal i stedet. Ingen risiko for evig loekke: refresh() kommer
    // tilbage med en rigtig kurv, og en RIGTIG tom kurv har items = [].
    if (!cart || typeof cart !== 'object' ||
        !cart.items || typeof cart.items.length !== 'number') {
      refresh();
      return;
    }
    var items = cart.items || [];
    if (elCount) elCount.textContent = cart.item_count === 1 ? '1 vare' : cart.item_count + ' varer';

    if (!items.length) {
      varerAntal = 0;
      if (erUdvidet) saetUdvidet(false, false); // tom kurv: intet at brede ud
      if (elItems) elItems.innerHTML = '';
      if (elEmpty) elEmpty.hidden = false;
      if (elFoot) elFoot.hidden = true;
      if (elShip) elShip.hidden = true;
      if (elRec) elRec.hidden = true;
      return;
    }
    if (elEmpty) elEmpty.hidden = true;
    if (elFoot) elFoot.hidden = false;
    if (elShip) elShip.hidden = false;

    // FASE 4.0.0: maal FOER DOM'en roeres. renderCart() erstatter hele
    // innerHTML, saa "foer"-positionerne gemmes paa data-key og kobles til de
    // nye noder bagefter. Uden dette maalte vi paa noder der allerede var vaek.
    var foerLayout = maalLinjer();
    varerAntal = items.length;

    // FIX 9: skip genbygning naar DOM allerede matcher (priser synkes dog).
    if (elItems && domMatchesServer(items)) {
      syncLinesFromServer(items);
    } else {
    // Linje-varer
    var html = '';
    items.forEach(function (it) {
      var st = splitTitle(it.product_title || it.title);
      var vlabel = variantLabel(it);
      var url = it.url || (cfg.routeRoot + 'products/' + (it.handle || ''));
      var img = it.image
        ? '<img src="' + esc(sized(it.image, 140)) + '" alt="" loading="lazy">'
        : '';
      var linePrice = ore(it.final_line_price);
      var unitOre = it.quantity ? Math.round(it.final_line_price / it.quantity) : it.final_line_price;
      var wasHtml = '';
      if (it.original_line_price && it.original_line_price > it.final_line_price) {
        wasHtml = '<span class="se-sc-line-was">' + money(ore(it.original_line_price)) + '</span>';
      }
      var bs = brandSplit(it);
      // Er lagergraensen lige naaet paa denne linje, faar den en rolig note.
      var lagerHtml = (lagerKey && it.key === lagerKey)
        ? '<div class="se-sc-lager">Det er alt, vi har p\u00e5 lager lige nu.</div>'
        : '';
      html +=
        '<div class="se-sc-item" data-key="' + esc(it.key) + '" data-unit="' + unitOre + '"' +
             ' data-vid="' + esc(it.variant_id) + '" data-handle="' + esc(it.handle || '') + '">' +
          '<a class="se-sc-thumb" href="' + esc(url) + '">' + img + '</a>' +
          '<div class="se-sc-mid">' +
            (bs.brand ? '<span class="se-sc-brand">' + esc(bs.brand) + '</span>' : '') +
            '<a class="se-sc-name" href="' + esc(url) + '">' + esc(bs.name) + '</a>' +
            (vlabel ? '<div class="se-sc-var">' + esc(vlabel) + '</div>' : '') +
            '<div class="se-sc-line-price">' + wasHtml + money(linePrice) + '</div>' +
          '</div>' +
          '<div class="se-sc-right">' +
            '<button class="se-sc-remove" type="button" data-key="' + esc(it.key) + '" aria-label="Fjern ' + esc(st.name) + '">' +
              '<svg viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>' +
            '</button>' +
            '<div class="se-sc-step" data-key="' + esc(it.key) + '">' +
              '<button type="button" class="se-sc-dec" aria-label="Færre">' + stepperSvg('minus') + '</button>' +
              // FASE 4.4.0: tallet kan trykkes paa og skrives. role=button +
              // tabindex, saa det ogsaa kan naas med tastatur. aria-label
              // baerer det rene tal (indholdet er to cifre under rullet).
              '<div class="se-sc-qty" role="button" tabindex="0" data-qty="' + it.quantity + '" aria-label="Antal ' + it.quantity + ', tryk for at skrive et antal"><span class="d">' + it.quantity + '</span></div>' +
              '<button type="button" class="se-sc-inc" aria-label="Flere">' + stepperSvg('plus') + '</button>' +
              // Antal annonceres fra en separat, visuelt skjult live-region.
              // aria-live paa selve rullet laeste "67" op (begge cifre i DOM
              // under animationen) — samme rod som "67"-bug'en, bare auditivt.
              '<span class="se-sc-sr" aria-live="polite">Antal: ' + it.quantity + '</span>' +
            '</div>' +
          '</div>' +
          lagerHtml +
        '</div>';
    });
    if (elItems) elItems.innerHTML = html;
    }

    // Subtotal med count-up
    // Punkt 12: total_price (efter kurv-rabatter) frem for items_subtotal.
    // Fragten er carrier-beregnet (Shipmondo — verificeret via Admin API:
    // DeliveryParticipant, ingen methodConditions i Shopify), og carrier-
    // rater faar checkoutens RABATTEREDE subtotal. total_price er taettest
    // paa det Shipmondo ser. Rabatkoder indtastet foerst i checkout kan
    // kurven principielt aldrig kende — grundvilkaar, ikke bug.
    // Lagerloft: hent for nye produkter, og laas plus paa dem vi allerede har.
    opdaterLagerData(items);

    // Antallet kan have krydset soejle-graensen. Omfordel bloedt hvis panelet
    // er udvidet; ellers saettes bare data-cols.
    anvendLayout(erUdvidet ? foerLayout : null);

    // Ny linjeliste betyder ny hoejde, saa markeringen skal regnes om.
    if (typeof opdaterFade === 'function') opdaterFade();

    var subtotal = ore(cart.total_price != null ? cart.total_price : cart.items_subtotal_price);
    animateSubtotal(subtotal);

    // Fri-fragt-progress
    renderShipping(subtotal);
  }

  // Subtotal count-up (samme princip som filter-resultat-tæller: ændringen selv
  // kommunikerer handlingen). Kort tween, ease-out.
  function animateSubtotal(to) {
    if (!elSubVal) return;
    var from = (lastSubtotal == null) ? to : lastSubtotal;
    lastSubtotal = to;
    if (from === to) { elSubVal.textContent = money(to); return; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { elSubVal.textContent = money(to); return; }
    var start = performance.now(), dur = 300;
    function tick(now) {
      var p = Math.min(1, (now - start) / dur);
      var e = 1 - Math.pow(1 - p, 3); // ease-out-cubic
      elSubVal.textContent = money(from + (to - from) * e);
      if (p < 1) requestAnimationFrame(tick);
      else elSubVal.textContent = money(to);
    }
    requestAnimationFrame(tick);
  }

  function renderShipping(subtotal) {
    if (!elShip) return;
    var threshold = cfg.freeShip;
    var remaining = threshold - subtotal;
    var msg = elShip.querySelector('.se-sc-ship-msg');
    var fill = elShip.querySelector('.se-sc-ship-fill');
    var pct = Math.max(0, Math.min(100, (subtotal / threshold) * 100));
    var near = pct >= 66 && remaining > 0;
    if (fill) {
      // SVG-baren: bredde som PROCENT-attribut (ingen viewBox-straekning, saa
      // rx-afrunding og kanter er rene). Fill + stroke er attributter — ingen
      // tema-CSS kan male den graa eller give den sort kant.
      var w = subtotal > 0 ? Math.max(pct, 4) : 0; // synlig nub ved smaa beloeb
      fill.setAttribute('width', w + '%');
      fill.setAttribute('fill', near ? '#0a2420' : '#1fd4b4');
      fill.setAttribute('stroke', 'none');
    }
    // Klasser bevares til evt. anden styling, men baren afhaenger ikke af dem.
    elShip.classList.toggle('has-progress', subtotal > 0);
    elShip.classList.toggle('is-near', near);
    if (remaining > 0) {
      elShip.classList.remove('is-reached');
      // "Kun" frem for "Endnu": samme tal, men rammer som et lille resttal
      // (naesten i maal) frem for en mangel. Roligt, ikke opfordrende.
      if (msg) msg.innerHTML =
        '<span class="ic"></span><span>Kun <b>' + money(remaining) + '</b> til fri fragt.</span>';
    } else {
      elShip.classList.add('is-reached');
      if (msg) msg.innerHTML =
        '<span class="ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>' +
        '<span>Du har fri fragt.</span>';
    }
  }

  // ── Stepper-interaktion med rullende ciffer ──
  function rollDigit(qtyEl, newVal, dir) {
    // dir: +1 (op) eller -1 (ned). Gammelt ciffer glider ud, nyt glider ind.
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // FASE 4.4.0: cifre der allerede er paa vej ud fjernes NU. Ellers staar
    // der ét span pr. hurtigt tryk, alle i flugt, oven i hinanden.
    var gamle = qtyEl.querySelectorAll('.d.out-up, .d.out-down');
    for (var g = 0; g < gamle.length; g++) {
      if (gamle[g].parentNode) gamle[g].parentNode.removeChild(gamle[g]);
    }
    var old = qtyEl.querySelector('.d');
    if (reduce || !old) { qtyEl.innerHTML = '<span class="d">' + newVal + '</span>'; return; }
    var next = document.createElement('span');
    next.className = 'd ' + (dir > 0 ? 'out-down' : 'out-up'); // starter modsat udgangen
    next.textContent = newVal;
    qtyEl.appendChild(next);
    // tving reflow, så overgangen sker
    void next.offsetWidth;
    old.classList.add(dir > 0 ? 'out-up' : 'out-down');
    next.classList.remove('out-down', 'out-up');
    setTimeout(function () { if (old && old.parentNode) old.parentNode.removeChild(old); }, 320);
  }

  // Egne kurv-skrivninger gaar gennem cartFetch, som taeller dem, saa det
  // delte watcher-register ikke udloeser en EKSTRA refresh() oveni vores eget
  // response-render (foer: to hentninger + to renders pr. aendring, der kunne
  // kappe ciffer-rullet). Ved netvaerksfejl rulles taelleren tilbage, saa en
  // fremtidig ekstern skrivning ikke faar sin refresh slugt.
  var selfWrites = 0;
  function cartFetch(url, payload) {
    selfWrites++;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function (err) { selfWrites = Math.max(0, selfWrites - 1); throw err; });
  }

  // ══════════════════════════════════════════════════════════════════════
  //  LAGERGRAENSE (FASE 4.3.0)
  // ══════════════════════════════════════════════════════════════════════
  var lagerCache = {};    // handle -> { variantId: {a, p} }
  var lagerHenter = {};   // handle -> true mens et kald er undervejs

  function hentLager(handle) {
    if (!handle || lagerCache[handle] || lagerHenter[handle]) return;
    lagerHenter[handle] = true;
    fetch(cfg.routeRoot + 'products/' + encodeURIComponent(handle) + '?view=lager',
          { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (svar) {
        delete lagerHenter[handle];
        if (svar && svar.v) { lagerCache[handle] = svar.v; anvendLagerGraenser(); }
      })
      .catch(function () {
        delete lagerHenter[handle];
        // Ingen lagerdata er ikke en fejl kunden skal maerke. Uden loft
        // opfoerer panelet sig praecis som foer, og 422-vaernet staar klar.
      });
  }

  // Returnerer loftet for en linje, eller null naar der ikke er noget.
  function lagerLoft(handle, variantId) {
    var pr = lagerCache[handle];
    if (!pr) return null;
    var info = pr[String(variantId)];
    if (!info) return null;
    if (info.a === null || typeof info.a !== 'number') return null; // ikke sporet
    if (info.p === 'continue') return null;                          // oversalg tilladt
    return info.a;
  }

  function anvendLagerGraenser() {
    if (!elItems) return;
    var linjer = elItems.querySelectorAll('.se-sc-item');
    for (var i = 0; i < linjer.length; i++) {
      var el = linjer[i];
      var handle = el.getAttribute('data-handle');
      var vid = el.getAttribute('data-vid');
      var inc = el.querySelector('.se-sc-inc');
      var qtyEl = el.querySelector('.se-sc-qty');
      if (!inc || !qtyEl) continue;
      var loft = lagerLoft(handle, vid);
      var antal = parseInt(qtyEl.getAttribute('data-qty'), 10) || 0;
      var ramt = (loft !== null && antal >= loft);
      inc.disabled = ramt;
      inc.setAttribute('aria-label', ramt ? 'Alt p\u00e5 lager ligger i kurven' : 'Flere');
      var note = el.querySelector('.se-sc-lager');
      if (ramt && !note) {
        note = document.createElement('div');
        note.className = 'se-sc-lager';
        note.textContent = loft === 1
          ? 'Vi har kun denne ene på lager.'
          : 'Det er alle ' + loft + ', vi har på lager.';
        el.appendChild(note);
      } else if (!ramt && note && note.parentNode && !lagerKey) {
        note.parentNode.removeChild(note);
      }
    }
  }

  // Bed om lagertal for de produkter der ligger i kurven lige nu.
  function opdaterLagerData(items) {
    if (!items || !items.length) return;
    var sete = {};
    for (var i = 0; i < items.length; i++) {
      var h = items[i].handle;
      if (h && !sete[h]) { sete[h] = true; hentLager(h); }
    }
    anvendLagerGraenser();
  }

  // Et svar fra /cart/*.js er kun en kurv naar status er ok. Ellers er kroppen
  // et fejlobjekt, og det maa ALDRIG naa renderCart().
  function kurvSvar(r) {
    return r.json().then(function (krop) {
      if (r.ok) return krop;
      var fejl = new Error('kurv-fejl');
      fejl.status = r.status;
      fejl.krop = krop;
      throw fejl;
    });
  }

  // Naar lageret siger nej, huskes linjen her og faar en besked ved naeste
  // gengivelse. Gemt paa key frem for paa DOM-noden, fordi renderCart()
  // erstatter hele innerHTML og noden derfor er vaek et oejeblik senere.
  var lagerKey = null, lagerTimer = null;
  function visLagergraense(key) {
    lagerKey = key;
    if (lagerTimer) clearTimeout(lagerTimer);
    lagerTimer = setTimeout(function () {
      lagerKey = null;
      var n = elItems && elItems.querySelector('.se-sc-lager');
      if (n && n.parentNode) n.parentNode.removeChild(n);
    }, 6000);
    try {
      if (typeof window.clarity === 'function') window.clarity('event', 'sidecart_lager_naaet');
    } catch (e) { /* stille */ }
  }

  var qtyTimers = {};
  var qtyInflight = {}; // key -> true mens et /change.js-kald er i luften
  var qtyDirty = {};    // key -> true naar tallet er aendret under et kald
  function findLine(key) {
    // Loop frem for attribut-selektor: keys indeholder ':' og skal ikke escapes.
    if (!elItems) return null;
    var lines = elItems.querySelectorAll('.se-sc-item');
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].getAttribute('data-key') === key) return lines[i];
    }
    return null;
  }
  function changeQty(key) {
    // Debounce pr. key: hurtige + / − samler sig til ét request. Antallet
    // laeses foerst naar kaldet sendes (fra data-qty), saa det altid er det
    // nyeste.
    if (qtyTimers[key]) clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      delete qtyTimers[key];
      sendQty(key);
    }, 260);
  }
  // FASE 4.4.0: aldrig mere end ét kald pr. linje ad gangen. Et svar paa et
  // tidligere antal kunne ellers naa frem EFTER kunden havde trykket videre,
  // og renderCart() skrev det gamle tal ind - "tallet sprang tilbage".
  function sendQty(key) {
    if (qtyInflight[key]) { qtyDirty[key] = true; return; }
    var line = findLine(key);
    if (!line) return;                  // linjen er fjernet imens
    var qe = line.querySelector('.se-sc-qty');
    var quantity = qe ? (parseInt(qe.getAttribute('data-qty'), 10) || 0) : 0;
    if (quantity < 1) return;           // fjernelse gaar sin egen vej (removeNow)
    qtyInflight[key] = true;
    cartFetch(cfg.cartUrl + '/change.js', { id: key, quantity: quantity })
      .then(kurvSvar)
      .then(function (cart) {
        delete qtyInflight[key];
        // Er tallet aendret imens (eller venter en debounce), er dette svar
        // foraeldet: tegn det ikke, send det nyeste i stedet.
        if (qtyDirty[key]) { delete qtyDirty[key]; sendQty(key); return; }
        if (qtyTimers[key]) return;
        lagerKey = null;                // det lykkedes: ingen besked
        renderCart(cart); loadRecommendations(cart);
      })
      .catch(function (fejl) {
        delete qtyInflight[key];
        delete qtyDirty[key];
        if (qtyTimers[key]) { clearTimeout(qtyTimers[key]); delete qtyTimers[key]; }
        // 422 = lageret raekker ikke. Alt andet er en rigtig fejl.
        if (fejl && fejl.status === 422) visLagergraense(key);
        refresh();                      // hent sandheden, rul det optimistiske tal tilbage
      });
  }

  // FASE 4.4.0: faelles vej for et nyt antal paa en linje, uanset om det kom
  // fra +/−, tastatur eller det skrevne felt. Optimistisk visning + debounced
  // kald. dir styrer rulleretningen; 0 = uden rul (skrevet antal).
  function anvendAntal(step, next, dir) {
    var key = step.getAttribute('data-key');
    var qtyEl = step.querySelector('.se-sc-qty');
    var raekke = step.closest('.se-sc-item');
    if (!qtyEl || !raekke) return;
    if (next < 1) {
      removeLineOptimistic(key, raekke);
      return;
    }
    var loft = lagerLoft(raekke.getAttribute('data-handle'), raekke.getAttribute('data-vid'));
    if (loft !== null && next > loft) next = loft;
    var cur = parseInt(qtyEl.getAttribute('data-qty'), 10) || 1;
    qtyEl.setAttribute('data-qty', next);
    qtyEl.setAttribute('aria-label', 'Antal ' + next + ', tryk for at skrive et antal');
    var sr = step.querySelector('.se-sc-sr');
    if (sr) sr.textContent = 'Antal: ' + next; // skaermlaeser faar det rene tal
    if (dir === 0) {
      qtyEl.innerHTML = '<span class="d">' + next + '</span>';
    } else if (next !== cur) {
      rollDigit(qtyEl, next, dir);        // optimistisk rulle for instant respons
    }
    optimisticLine(raekke, next);
    anvendLagerGraenser();
    if (next !== cur || dir === 0) changeQty(key);
  }

  // ── Skriv antal (FASE 4.4.0) ──
  // Tryk paa tallet aabner et felt i samme flade. Enter/blur gemmer, Escape
  // fortryder. Feltet er type=text med inputmode=numeric: type=number giver
  // spinnere og accepterer 'e' og '-', som vi ikke vil have.
  function aabnAntalFelt(qtyEl) {
    var step = qtyEl.closest('.se-sc-step');
    if (!step || step.querySelector('.se-sc-qty-in')) return;
    var cur = parseInt(qtyEl.getAttribute('data-qty'), 10) || 1;
    var inp = document.createElement('input');
    inp.className = 'se-sc-qty-in';
    inp.type = 'text';
    inp.setAttribute('inputmode', 'numeric');
    inp.setAttribute('pattern', '[0-9]*');
    inp.setAttribute('maxlength', '3');
    inp.setAttribute('aria-label', 'Antal');
    inp.setAttribute('autocomplete', 'off');
    inp.value = String(cur);
    var faerdig = false;
    function luk(gem) {
      if (faerdig) return;
      faerdig = true;
      var raa = inp.value.replace(/[^0-9]/g, '');
      if (inp.parentNode) inp.parentNode.removeChild(inp);
      qtyEl.hidden = false;
      if (!gem || raa === '' || raa === String(cur)) return;
      anvendAntal(step, parseInt(raa, 10), 0);
    }
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); luk(true); }
      // Escape maa ikke naa panelet: der lukker den hele kurven.
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); luk(false); if (usingKeyboard) qtyEl.focus(); }
    });
    inp.addEventListener('blur', function () { luk(true); });
    qtyEl.hidden = true;
    qtyEl.parentNode.insertBefore(inp, qtyEl);
    inp.focus();
    try { inp.select(); } catch (e) { /* stille */ }
  }

  // Optimistisk opdatering af én linje (pris, subtotal, fri-fragt) FØR serveren
  // svarer — saa + og − foeles instant og glat, ikke forsinket.
  // Kendt og accepteret (punkt 13): data-unit er afrundet til hele oere, saa
  // ved skaeve rabatter (fx 3-for-2) kan den optimistiske sum drive en oere
  // fra serverens — syncLinesFromServer retter den stille ved naeste svar.
  function optimisticLine(itemEl, newQty) {
    if (!itemEl) return;
    var unit = parseFloat(itemEl.getAttribute('data-unit') || '0'); // øre pr. stk.
    var priceEl = itemEl.querySelector('.se-sc-line-price');
    if (priceEl && unit) priceEl.textContent = money(ore(unit * newQty));
    // Genberegn subtotal ud fra alle synlige linjer (optimistisk).
    var sum = 0;
    var lines = elItems.querySelectorAll('.se-sc-item');
    for (var i = 0; i < lines.length; i++) {
      var u = parseFloat(lines[i].getAttribute('data-unit') || '0');
      var qe = lines[i].querySelector('.se-sc-qty');
      var q = qe ? (parseInt(qe.getAttribute('data-qty'), 10) || 0) : 0; // data-qty, ikke animeret tekst
      sum += u * q;
    }
    animateSubtotal(ore(sum));
    renderShipping(ore(sum));
  }

  // Delegér stepper/remove-klik (indhold gen-renders, så vi binder på panelet)
  if (elItems) {
    elItems.addEventListener('click', function (e) {
      var inc = e.target.closest && e.target.closest('.se-sc-inc');
      var dec = e.target.closest && e.target.closest('.se-sc-dec');
      var rm  = e.target.closest && e.target.closest('.se-sc-remove');
      var qtyTap = e.target.closest && e.target.closest('.se-sc-qty');
      if (inc || dec) {
        var step = inc ? inc.closest('.se-sc-step') : dec.closest('.se-sc-step');
        var qtyEl = step.querySelector('.se-sc-qty');
        // LÆS ALDRIG antallet fra textContent: under rulle-animationen staar
        // baade gammelt og nyt ciffer i DOM'en ("6"+"7" -> "67"), saa parseInt
        // gav 67 — baren floej i "fri fragt" og serveren kunne faa forkert antal.
        // data-qty er sandheden; teksten er kun visning.
        var cur = parseInt(qtyEl.getAttribute('data-qty'), 10) || 1;
        // Loftet tjekkes ogsaa her. Knappen er deaktiveret, men et tastatur
        // eller en hurtig dobbelt-tap kan naa at fyre et klik alligevel.
        if (inc) {
          var raekke = inc.closest('.se-sc-item');
          var loft = raekke ? lagerLoft(raekke.getAttribute('data-handle'),
                                        raekke.getAttribute('data-vid')) : null;
          if (loft !== null && cur >= loft) { anvendLagerGraenser(); return; }
        }
        // Ned under 1 = fjern varen — OPTIMISTISK og instant, praecis som
        // skraldespanden (haandteres i anvendAntal).
        anvendAntal(step, inc ? cur + 1 : cur - 1, inc ? 1 : -1);
      } else if (qtyTap) {
        aabnAntalFelt(qtyTap);
      } else if (rm) {
        removeLineOptimistic(rm.getAttribute('data-key'), rm.closest('.se-sc-item'));
      }
    });
  }

  // Enter/mellemrum paa tallet aabner feltet (role=button skal kunne betjenes
  // med tastatur).
  if (elItems) {
    elItems.addEventListener('keydown', function (e) {
      var q = e.target && e.target.classList && e.target.classList.contains('se-sc-qty') ? e.target : null;
      if (!q) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); aabnAntalFelt(q); }
    });
  }

  // Faelles optimistisk fjernelse (skraldespand OG minus-til-nul): linjen ud af
  // DOM'en nu, totaler genberegnes, request uden debounce. Ingen ventetid.
  function removeLineOptimistic(key, itemEl) {
    if (itemEl && itemEl.parentNode) itemEl.parentNode.removeChild(itemEl);
    recomputeTotalsFromDom();
    removeNow(key);
  }

  // Fjern uden debounce (instant), reconcil stille fra svaret.
  function removeNow(key) {
    if (qtyTimers[key]) { clearTimeout(qtyTimers[key]); delete qtyTimers[key]; }
    delete qtyDirty[key];               // et evt. kald i luften maa ikke sende igen
    cartFetch(cfg.cartUrl + '/change.js', { id: key, quantity: 0 })
      .then(kurvSvar)
      .then(function (cart) { renderCart(cart); loadRecommendations(cart); })
      .catch(function () { refresh(); });
  }

  // Genberegn subtotal + fri-fragt ud fra de synlige linjer (efter optimistisk
  // fjernelse). Tom kurv -> vis tom-tilstand med det samme.
  function recomputeTotalsFromDom() {
    var lines = elItems.querySelectorAll('.se-sc-item');
    if (!lines.length) {
      // ingen varer tilbage: vis tom-tilstand optimistisk
      if (elEmpty) elEmpty.hidden = false;
      if (elFoot) elFoot.hidden = true;
      if (elShip) elShip.hidden = true;
      if (elRec) elRec.hidden = true;
      if (elCount) elCount.textContent = '0 varer';
      return;
    }
    var sum = 0, count = 0;
    for (var i = 0; i < lines.length; i++) {
      var u = parseFloat(lines[i].getAttribute('data-unit') || '0');
      var qe = lines[i].querySelector('.se-sc-qty');
      var q = qe ? (parseInt(qe.getAttribute('data-qty'), 10) || 0) : 0; // data-qty, ikke animeret tekst
      sum += u * q; count += q;
    }
    if (elCount) elCount.textContent = count === 1 ? '1 vare' : count + ' varer';
    animateSubtotal(ore(sum));
    renderShipping(ore(sum));
  }

  // ── Anbefalinger (Shopify /recommendations/products) ──
  // Cache pr. grundlag (foerste vares produkt-id). Listen re-filtreres mod
  // kurvens AKTUELLE indhold ved hver kurv-aendring — foer froes den efter
  // foerste load: en fjernet anbefalet vare kom aldrig tilbage, og en netop
  // tilfoejet blev staaende. Skifter grundlaget (ny foerste vare), hentes nyt.
  var recCache = null; // { pid, products }
  // FASE 4.4.0: anbefalinger lagt i kurven herfra bliver STAAENDE med et
  // flueben, saa laenge varen ligger i kurven. Foer forsvandt kortet ved
  // naeste gengivelse (varen var jo i kurven), og fluebenet naaede knap at
  // blive set. Fjernes varen igen, bliver kortet et plus igen.
  var recAdded = {};   // product_id -> true
  function loadRecommendations(cart) {
    if (!cfg.recommend || !elRec) return;
    var items = cart.items || [];
    if (!items.length) { elRec.hidden = true; return; }
    var pid = items[0].product_id;
    if (!pid) { elRec.hidden = true; return; }
    if (recCache && recCache.pid === pid) { renderRecFiltered(recCache.products, items); return; }
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + encodeURIComponent(cfg.recIntent),
      { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        recCache = { pid: pid, products: (data.products || []) };
        renderRecFiltered(recCache.products, items);
      })
      .catch(function () { elRec.hidden = true; });
  }
  function renderRecFiltered(prods, items) {
    var inCart = {};
    items.forEach(function (it) { inCart[it.product_id] = true; });
    // FASE 3.2.0: praecis tre anbefalinger — deler vinduets bredde, ingen
    // scroll. Motoren henter stadig hele saettet; kun visningen skaeres.
    var list = prods.filter(function (p) {
      if (recAdded[p.id] && !inCart[p.id]) delete recAdded[p.id];
      return !inCart[p.id] || recAdded[p.id];
    }).slice(0, 3);
    if (!list.length) { elRec.hidden = true; return; }
    renderRec(list);
    elRec.hidden = false;
  }

  function renderRec(prods) {
    var row = elRec.querySelector('.se-sc-rec-row');
    if (!row) return;
    var html = '';
    prods.forEach(function (p) {
      var st = splitTitle(p.title);
      // FASE 4.4.0: maerket som lille label over navnet, saa navnet ikke
      // klippes af "Precision Fuel & Hydration ..." i den kompakte raekke.
      var rb = brandSplit({ product_title: p.title, vendor: p.vendor });
      var img = (p.featured_image || (p.images && p.images[0])) || '';
      var v = (p.variants && p.variants[0]) || null;
      var vid = v ? v.id : null;
      var price = v && v.price != null ? ore(v.price) : (p.price != null ? ore(p.price) : null);
      var imgTag = img ? '<img src="' + esc(sized(img, 120)) + '" alt="" loading="lazy">' : '';
      html +=
        // FASE 3.5.0: data-attributter til effektivitets-sporene (GA4/Clarity).
        // Prisen er allerede kroner (ore() ovenfor). Titel er kort-navnet.
        '<div class="se-sc-rec-card" data-pid="' + esc(String(p.id || '')) +
          '" data-title="' + esc(st.name) +
          '" data-price="' + (price != null ? price : '') + '">' +
          '<a class="ph" href="' + esc(p.url) + '">' + imgTag + '</a>' +
          '<div class="se-sc-rec-mid">' +
            (rb.brand && rb.name !== st.name ? '<span class="se-sc-rec-brand">' + esc(rb.brand) + '</span>' : '') +
            '<a class="se-sc-rec-nm" href="' + esc(p.url) + '">' + esc(rb.name) + '</a>' +
            (price != null ? '<div class="se-sc-rec-pr">' + money(price) + '</div>' : '') +
          '</div>' +
          (vid ? (recAdded[p.id]
            ? '<button class="se-sc-rec-add is-added" type="button" data-vid="' + vid + '" aria-label="' + esc(st.name) + ' ligger i kurven">' + fluebenSvg() + '<span class="se-sc-rec-add-t">Lagt i</span></button>'
            : '<button class="se-sc-rec-add" type="button" data-vid="' + vid + '" aria-label="Læg ' + esc(st.name) + ' i kurv">' +
            '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg><span class="se-sc-rec-add-t">Læg i kurv</span></button>') : '') +
        '</div>';
    });
    row.innerHTML = html;
  }

  function fluebenSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  }

  // ── Maaling af anbefalings-effektivitet (FASE 3.5.0) ──
  // Fyrer tre spor naar en anbefaling laegges i kurven. Alt defensivt: en
  // manglende analytics-funktion maa ALDRIG kunne knaekke kurv-flowet.
  function trackRecAdd(info) {
    // GA4 — standard add_to_cart med source-markoer. Bruger gtag hvis den
    // findes, ellers dataLayer.push (begge virker med GA4).
    try {
      var payload = {
        currency: 'DKK',
        value: (info.price != null ? info.price : 0),
        se_source: 'sidecart_anbefaling',
        items: [{
          item_id: String(info.pid || ''),
          item_name: info.title || '',
          item_variant: String(info.vid || ''),
          price: (info.price != null ? info.price : 0),
          quantity: 1
        }]
      };
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'add_to_cart', payload);
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'add_to_cart', ecommerce: payload });
      }
    } catch (e) {}
    // Clarity — custom tag (til at filtrere sessions) + event.
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'recommendation_added', info.title || 'ukendt');
        window.clarity('event', 'sidecart_recommendation_added');
      }
    } catch (e) {}
  }

  if (elRec) {
    elRec.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.se-sc-rec-add');
      if (!btn) return;
      var vid = btn.getAttribute('data-vid');
      if (!vid || btn.classList.contains('is-added')) return;
      // Metadata til sporene: hent fra kortet (data-attributter sat i renderRec).
      var card = btn.closest('.se-sc-rec-card');
      var recInfo = {
        vid: vid,
        pid: card ? card.getAttribute('data-pid') : '',
        title: card ? card.getAttribute('data-title') : '',
        price: card ? parseFloat(card.getAttribute('data-price')) : null
      };

      // Optimistisk: vis flueben ØJEBLIKKELIGT (instant respons, fluid-princip),
      // fyr requesten i baggrunden, rul kun tilbage hvis den fejler.
      var prevHTML = btn.innerHTML;
      btn.classList.add('is-added');
      btn.innerHTML = fluebenSvg() + '<span class="se-sc-rec-add-t">Lagt i</span>';
      btn.setAttribute('aria-label', (recInfo.title || 'Varen') + ' ligger i kurven');
      if (recInfo.pid) recAdded[recInfo.pid] = true;

      // Skjult line item property (underscore = skjult for kunden, synlig i
      // admin/paa ordren). Foelger varen hele vejen til ordren, saa du kan se
      // direkte hvilke koeb der kom fra en anbefaling.
      cartFetch(cfg.cartUrl + '/add.js', {
        id: vid, quantity: 1,
        properties: { '_kilde': 'sidecart-anbefaling' }
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { trackRecAdd(recInfo); refresh(); }) // spor kun ved bekraeftet add
        .catch(function () {
          // Rul tilbage: gendan knappen, saa kunden kan proeve igen.
          if (recInfo.pid) delete recAdded[recInfo.pid];
          btn.classList.remove('is-added');
          btn.innerHTML = prevHTML;
        });
    });
  }

  // ── Hent + tegn ──
  var refreshing = false;
  function refresh() {
    if (refreshing) return;
    refreshing = true;
    fetch(cfg.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        loadRecommendations(cart);
        refreshing = false;
      })
      .catch(function () { refreshing = false; });
  }

  // ── Drag-to-dismiss (mod højre — rumlig konsistens med åbnings-retningen) ──
  // Fire fluid-principper: retning afgøres efter ~10px langs den relevante akse,
  // modsat-retning rubber-bander (blød grænse), hurtige flicks lukker via
  // velocity, backdrop følger fingeren 1:1. Kun i toppanelet (head), saa scroll
  // i listen ikke spaerres.
  // FASE 3.0.0: aksen afhaenger af formen. Desktop = svaevende vindue, lukkes
  // mod HOEJRE (samme retning som foer). Mobil = bottom-sheet, lukkes NEDAD.
  // Vi maaler viewport ved drag-start, saa et skift i orientering rammer rigtigt.
  (function armDrag() {
    var head = panel.querySelector('.se-sc-head');
    if (!head) return;
    var startX = 0, startY = 0, d = 0, dragging = false, decided = false, active = false;
    var vertical = false, last = 0, lastT = 0, vel = 0;
    var DECIDE_AT = 10, DISMISS_AT = 80, FLICK_V = 0.5;
    function isSheet() { return window.matchMedia('(max-width:520px)').matches; }
    head.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      vertical = isSheet();                 // sheet lukker nedad, vindue mod hoejre
      last = vertical ? startY : startX; lastT = e.timeStamp; vel = 0;
      d = 0; dragging = true; decided = false; active = false;
      holdWill();
    }, { passive: true });
    head.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var x = e.touches[0].clientX, y = e.touches[0].clientY;
      if (!decided) {
        var adx = Math.abs(x - startX), ady = Math.abs(y - startY);
        if (adx < DECIDE_AT && ady < DECIDE_AT) return;
        decided = true;
        // aktiv kun hvis bevaegelsen foelger lukke-aksen (ellers: lad scroll passere)
        active = vertical ? (ady > adx) : (adx > ady);
        if (active) { panel.style.transition = 'none'; if (backdrop) backdrop.style.transition = 'none'; }
      }
      if (!active) return;
      var cur = vertical ? y : x, start = vertical ? startY : startX;
      var raw = cur - start;
      d = raw > 0 ? raw : raw / 4;           // lukke-retning 1:1, modsat rubber-bander
      panel.style.transform = vertical ? ('translateY(' + d + 'px)') : ('translateX(' + d + 'px)');
      var span = vertical ? panel.offsetHeight : panel.offsetWidth;
      if (backdrop && d > 0) backdrop.style.opacity = Math.max(0, 1 - d / span);
      var t = e.timeStamp, dt = t - lastT;
      if (dt >= 3) { vel = 0.4 * vel + 0.6 * ((cur - last) / dt); last = cur; lastT = t; }
    }, { passive: true });
    head.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      releaseWill();
      panel.style.transition = ''; panel.style.transform = '';
      if (backdrop) { backdrop.style.transition = ''; backdrop.style.opacity = ''; }
      if (d > DISMISS_AT || (d > 30 && vel > FLICK_V)) close();
    });
  })();

  // ── Dead-click-maaler (FASE 3.9.0) ──
  // Et klik inde i panelet der IKKE rammer en kontrol er et signal om at kunden
  // leder efter noget vi ikke har gjort tydeligt nok. Maks ét pr. aabning, saa
  // det ikke stoejer. Samme seg_track-moenster som guiden og traeningsberegneren.
  // Alt i try/catch: analytics maa aldrig kunne knaekke kurv-flowet.
  function sidecartZone(el) {
    if (!el || !el.closest) return 'ukendt';
    if (el.closest('.se-sc-head'))  return 'head';
    if (el.closest('.se-sc-ship'))  return 'ship';
    if (el.closest('.se-sc-items')) return 'items';
    if (el.closest('.se-sc-empty')) return 'empty';
    if (el.closest('.se-sc-rec'))   return 'rec';
    if (el.closest('.se-sc-foot'))  return 'foot';
    return 'panel';
  }
  panel.addEventListener('click', function (e) {
    if (deadClickSendt) return;
    var t = e.target;
    if (t && t.closest && t.closest('a, button, input, select, textarea, [role="button"]')) return;
    deadClickSendt = true;
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'sc_dead_zone', sidecartZone(t));
        window.clarity('event', 'sidecart_dead_click');
      }
    } catch (err) { /* stille fejl */ }
  });

  // Første tal ved load (så badge/tal er rigtige selv før åbning)
  refresh();

  // ── Kurv-ikonerne kapres HELT til sidst (FASE 3.9.0) ──
  // Kaldet laa foer 20 pct inde i filen, med 80 pct af initialiseringen
  // bagefter. Kastede noget af det, var ikonet allerede kapret: preventDefault
  // uden et panel der kunne aabne, altså et dodt ikon. Nu bindes der foerst alt
  // ovenfor er kommet igennem, saa en fejl undervejs efterlader et almindeligt
  // link til /cart frem for ingenting.
  bindCartTriggers();
  // Ikonerne bor i header/mobil-JS' egne DOM — bind igen efter et øjeblik hvis
  // de tilføjes sent (fx portal-flytning i mobil-nav).
  setTimeout(bindCartTriggers, 300);
  setTimeout(bindCartTriggers, 1200);
})();